export const CardIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 5.66992H14.6668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 11.0034H5.33334"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11.0034H9.66667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.2935 2.33643H11.7002C14.0735 2.33643 14.6668 2.92309 14.6668 5.2631V10.7364C14.6668 13.0764 14.0735 13.6631 11.7068 13.6631H4.2935C1.92683 13.6698 1.3335 13.0831 1.3335 10.7431V5.2631C1.3335 2.92309 1.92683 2.33643 4.2935 2.33643Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
